import React, {Component} from "react";
import Translate from "react-translate-component";
import {Form} from "react-bootstrap";
import {Typeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import {Tabs, Tab} from "react-bootstrap";
import {connect} from "react-redux";
import {getAllData} from "../../actions/actions";
import Chart from "../Chart/chart";
import Tables from "../Tables/Tables";
import "react-bootstrap-typeahead/css/Typeahead.css";
// import counterpart from "counterpart";
// import {Button} from "react-bootstrap";

import "./SearchForm.css";
// let sectorDropDown = [];
let passDataArr = [];
class SearchForm extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);

    this.state = {
      tradeType: "",
      industryData: [],
      hsCodeData: [],
      sectorData: [],
      regionsData: [],
      countriesData: [],
      tabsData: [],
      activeTab: [],
      chartData: [],
      tableData: [],
      lang: "en",
      showTabComponent: false,
      loading: false,
    };
    console.log("State: ", this.state);
  }

  // Know the type of trade of the user (Import or export)
  handleTradeData = (e) => {
    this.setState({
      tradeType: e.target.value,
    });
  };
  // Handling API Request
  getChartData = (e) => {
    // These 3 variables below for complete the API request
    // let industryData = this.state.industryData[0].indValue;
    // let sectorData = this.state.sectorData[0].sectorValue;
    // const dataURL = `https://run.mocky.io/v3/a7560847-dcac-463d-b5d5-5f85cff4b965`; //Import: a7560847-dcac-463d-b5d5-5f85cff4b965
    // const dataURL = `https://run.mocky.io/v3/${tradeType}`; //Export: 8709dc64-b45e-43db-a7ed-fa9ffd3c45a4
    const dataURL = "https://follow.leafwaysco.com/tradegate/apis/dummy2.php";
    // Store the search inputs data
    let countryIds = [];
    for (let i = 0; i < this.state.countriesData.length; i++) {
      const country = this.state.countriesData[i];
      countryIds.push(country.country_id);
    }
    const postData = {
      tradeType: this.state.tradeType,
      // industry: this.state.industryData[0].indValue,
      hsCode: this.state.hsCodeData[0].id,
      // sector: this.state.sectorData[0].sectorValue,
      regions: this.state.regionsData,
      countries: countryIds,
      context: this.props.context ? "development" : "discover",
      lang: this.state.lang,
    };
    console.log(postData);
    // Api request
    axios
      .post(dataURL, postData)
      .then((res) => {
        console.log(res);
        this.setState({
          tabsData: res.data,
        });
        console.log(this.state.tabsData[0].modules[0].data);
        let tabsContainer = [];
        let modulesContainer = [];
        // Loop on request data to know how many tabs in come from the API request
        for (let i = 0; i < this.state.tabsData.length; i++) {
          let tab = this.state.tabsData[i];
          for (let x = 0; x < tab.modules.length; x++) {
            let module = tab.modules[x];
            console.log(module);
            // Check to the type of the data
            // if it's a "Table" It will render the Table Component and send the component data in props "module"
            if (module.type.indexOf("table") !== -1) {
              modulesContainer.push(
                <Tables key={Math.random()} module={module} />
              );
            } else {
              // if it's a "Chart" It will render the Chart Component
              modulesContainer.push(
                <Chart key={Math.random()} module={module} />
              );
            }
          }
          // Inject the collected data (Tables + Charts) Components from the API inside the Tabs Container
          tabsContainer.push(
            <Tab eventKey={`tab` + i} title={tab.tabName} key={Math.random()}>
              {modulesContainer}
            </Tab>
          );
          // Remove all Data in "modulesContainer" every API request to update the tabs and the data
          modulesContainer = [];
        }
        passDataArr = [];
        console.log(passDataArr);
        passDataArr = tabsContainer;
        console.log(passDataArr);
      })
      .then(() => {
        // The Keys below for rendering the tabs container only when the User makes a request and handling data has finished
        this.setState({
          showTabComponent: true,
        });
      });
  };
  render() {
    return (
      <div className="tradeOpt">
        <h3 className="mt-2 mb-4">{this.props.title}</h3>
        <Translate
          content="searchControl.searchForm.labelHead"
          component="label"
        />
        <input
          type="radio"
          id={this.props.context + "-export"}
          name={this.props.context + "-trade"}
          value="export"
          onChange={this.handleTradeData}
        />
        <Translate
          content="searchControl.searchForm.labelInput1"
          component="label"
          htmlFor={this.props.context + "-export"}
        />
        <input
          type="radio"
          id={this.props.context + "-import"}
          name={this.props.context + "-trade"}
          value="import"
          onChange={this.handleTradeData}
        />
        <Translate
          content="searchControl.searchForm.labelInput2"
          component="label"
          htmlFor={this.props.context + "-import"}
        />
        <br />

        <Form.Group className="SearchForm">
          <Typeahead
            id="hsCodeData"
            labelKey="text"
            onChange={(selected) => {
              this.setState({hsCodeData: selected});
              try {
                if (selected !== "") {
                  document.querySelector(".regions-container").style.display =
                    "block";
                  document.querySelector(".countries-container").style.display =
                    "block";
                } else {
                  document.querySelector(".regions-container").style.display =
                    "none";
                  document.querySelector(".countries-container").style.display =
                    "none";
                }
              } catch (e) {
                console.log(e);
              }
            }}
            options={this.props.codes}
            placeholder={"Choose your industry"}
            selected={this.state.hsCodeData}
            maxResults={5}
          />
        </Form.Group>

        {this.props.context === "development" ? (
          <React.Fragment>
            <Form.Group className="SearchForm">
              <Typeahead
                id="traderegions"
                className="regions-container"
                labelKey="name"
                onChange={(selected) => {
                  this.setState({regionsData: selected});
                }}
                options={["test1", "test2"]}
                placeholder={"Choose by regions"}
                selected={this.state.regionsData}
                multiple
              />
            </Form.Group>
            <Form.Group className="SearchForm">
              <Typeahead
                id="tradecountries"
                className="countries-container"
                labelKey="country_name"
                onChange={(selected) => {
                  this.setState({countriesData: selected});
                }}
                options={this.props.countries}
                placeholder={"Choose by countries"}
                selected={this.state.countriesData}
                multiple
              />
              <Translate
                content="searchControl.searchForm.searchInput"
                component="button"
                className="btn btn-danger"
                onClick={() => {
                  this.getChartData();
                }}
              />
            </Form.Group>
          </React.Fragment>
        ) : (
          <Translate
            content="searchControl.searchForm.searchInput"
            component="button"
            className="btn btn-danger"
            onClick={() => {
              this.getChartData();
            }}
          />
        )}
        {this.state.showTabComponent ? (
          <Tabs defaultActiveKey="tab0" id="uncontrolled-tab-example">
            {passDataArr}
          </Tabs>
        ) : (
          ""
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    newData: state,
  };
}
export default connect(mapStateToProps, {getAllData})(SearchForm);
